import { onlyCallFnOnceWhilePreviousCallIsPending, promiseTimeout, wait } from "libs/promise-utils";
import React from "react";
import { isLoading } from "~/environment/createEnvironment";
import { PersistedDatabaseWorkerService } from "~/environment/PersistedDatabaseWorkerService";

/**
 * A view that is shown when an unexpected error occurs.
 */
export function GlobalErrorView(props: { message: string; code: string }) {
  const refresh = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    reloadAllTabsAndReinstallCommsDatabase();
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="max-w-sm">
        <h1 className="font-semibold text-xl mb-2">We found an unexpected error.</h1>
        <p>{props.message}</p>
        <p className="my-4">
          <a href="#" onClick={refresh} className="text-blue-10">
            Click here
          </a>{" "}
          to try again. If the problem persist contact us at team@comms.day.
        </p>
        <p className="text-slate-8">Error code {props.code}</p>
      </div>
    </div>
  );
}

const reloadAllTabsAndReinstallCommsDatabase = onlyCallFnOnceWhilePreviousCallIsPending(async () => {
  using disposable = isLoading.add();

  try {
    await promiseTimeout(2000, PersistedDatabaseWorkerService.reloadAllTabsAndReinstallCommsDatabase());
  } finally {
    // Wait to give time for Comms to handle the call to reloadAllTabsAndReinstallCommsDatabase.
    await wait(6000);

    // In case the call to `reloadAllTabsAndReinstallCommsDatabase` doesn't work as expected, we
    // fallback to manually reloading the page.
    window.location.reload();
  }
});
